import FabricCanvasTool from './fabrictool';

class Nomal extends FabricCanvasTool {
  configureCanvas(props) {
    let canvas = this._canvas;
    canvas.isDrawingMode = false;
    canvas.selection = false;
    canvas.forEachObject((o) => { o.selectable = o.evented = false; });
    canvas.defaultCursor = 'default';
    canvas.hoverCursor = 'default';
  }
}

export default Nomal;
